// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IeCircleFilledSvg from "@ant-design/icons-svg/es/asn/IeCircleFilled";
import AntdIcon from '../components/AntdIcon';

var IeCircleFilled = function IeCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: IeCircleFilledSvg
  }));
};

IeCircleFilled.displayName = 'IeCircleFilled';
export default React.forwardRef(IeCircleFilled);